import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { HttpParamsEncoder } from '../../tools';
import { Observable } from "rxjs";
import { Warehouse, DataSourceResponse } from "../../models";

@Injectable({ providedIn: 'root' })
export class WarehouseService extends ApiService {
  endPoint = '/api/warehouses';
  create(model: Warehouse) {
    return this.http.post(`${this.pharmacyUrl}${this.endPoint}`, model);
  }

  update(id: string, model: Warehouse) {
    return this.http.put(`${this.pharmacyUrl}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.pharmacyUrl}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.pharmacyUrl}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Warehouse> {
    return this.http.get<Warehouse>(`${this.pharmacyUrl}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Warehouse>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.pharmacyUrl}${this.endPoint}`, { params });
  }
  getAllList(queryParams: any): Observable<DataSourceResponse<Warehouse>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.pharmacyUrl}${this.endPoint}/all`, { params });
  }
}